import React, {useEffect, useState} from 'react';
import {useLocation, useParams} from "react-router-dom";
import {useFetching} from "../../hooks/useFetching";
import ApiOtherGame from "../../services/Game/OtherGame";
import {API_OTHER_GAME, GAMES_ROUTE, INDEX_ROUTE} from "../../utils/consts";
import GameBox from "../GameBox";
import {NavLink} from "react-router-dom";
import GenerateURL from "../../utils/generateURL";
import {useTranslation} from "react-i18next";
import {observer} from "mobx-react-lite";

// import image from "../../img/Bananas.png";

const OtherGame = () => {
    const { t } = useTranslation();
    const location = useLocation();
    const params = useParams();

    const [games, setGames] = useState(null);
    // const [games, setGames] = useState([ { id: 1, game_id: '1065', top_game: true, game_new: true, name: 'Rise Of Imperium', game_type: 'slot', free_game: false, image: image, game_reels: '7', bonus_game: true, play_game_url: 'https://demo.championstudio.net/?p=%7B%22back_url%22%3A%20%22https%3A//championstudio.net/ru/game/65/%22%2C%20%22game_id%22%3A%201063%2C%20%22login_code%22%3A%20%22%5B%5B00000000000000%5D%5D%22%2C%20%22game_exit%22%3A%20%22%5B%5Bclose%5D%5D%22%7D', }, { id: 2, game_id: '1065', top_game: true, game_new: true, name: 'Rise Of Imperium', game_type: 'slot', free_game: false, image: image, game_reels: '7', bonus_game: true, play_game_url: 'https://demo.championstudio.net/?p=%7B%22back_url%22%3A%20%22https%3A//championstudio.net/ru/game/65/%22%2C%20%22game_id%22%3A%201063%2C%20%22login_code%22%3A%20%22%5B%5B00000000000000%5D%5D%22%2C%20%22game_exit%22%3A%20%22%5B%5Bclose%5D%5D%22%7D', }, { id: 3, game_id: '1065', top_game: true, game_new: true, name: 'Rise Of Imperium', game_type: 'slot', free_game: false, image: image, game_reels: '7', bonus_game: true, play_game_url: 'https://demo.championstudio.net/?p=%7B%22back_url%22%3A%20%22https%3A//championstudio.net/ru/game/65/%22%2C%20%22game_id%22%3A%201063%2C%20%22login_code%22%3A%20%22%5B%5B00000000000000%5D%5D%22%2C%20%22game_exit%22%3A%20%22%5B%5Bclose%5D%5D%22%7D', }, { id: 4, game_id: '1065', top_game: true, game_new: true, name: 'Rise Of Imperium', game_type: 'slot', free_game: false, image: image, game_reels: '7', bonus_game: true, play_game_url: 'https://demo.championstudio.net/?p=%7B%22back_url%22%3A%20%22https%3A//championstudio.net/ru/game/65/%22%2C%20%22game_id%22%3A%201063%2C%20%22login_code%22%3A%20%22%5B%5B00000000000000%5D%5D%22%2C%20%22game_exit%22%3A%20%22%5B%5Bclose%5D%5D%22%7D', } ]);

    const [FunctionApiOtherGame, isLoading] = useFetching(async (id) => {
        const response = await ApiOtherGame.getApiOtherGame(API_OTHER_GAME, id);
        setGames(response.data.games);
    });

    useEffect(() => {
        FunctionApiOtherGame(params.id);
    }, [params.id]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <>
            {!isLoading && games && games.length > 0 && <div className="new_games">
                <div className="row">
                    <div className="title_block">
                        <h1>{t('Other')} {t('Games')}</h1>
                    </div>
                    <div className="boxing_games">
                        {games.map(game => <GameBox key={game.id} game={game} />)}
                    </div>
                    <div className="bottom_block">
                        <div className="bottom_block_text">
                            {location.pathname.indexOf('/main') !== -1
                                ? <NavLink to={GenerateURL(INDEX_ROUTE)}>{t('Go to Main')}</NavLink>
                                : <NavLink to={GenerateURL(GAMES_ROUTE)}>{t('Go to Games')}</NavLink>
                            }
                        </div>
                    </div>
                </div>
            </div>}
        </>
    );
};

export default observer(OtherGame);